import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {
    processes: [
      /* {
        _id: 1,
        name: "Proceso de Onboarding",
        description: "Proceso completo de incorporación de nuevos empleados",
        status: "active",
        createdDate: "2024-01-15",
        lastModified: "2024-01-20",
        collaborators: [
          {
            id: 1,
            name: "Ana García",
            avatar:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          },
          {
            id: 2,
            name: "Carlos López",
            avatar:
              "https://plus.unsplash.com/premium_photo-1689568126014-06fea9d5d341?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          },
          {
            id: 3,
            name: "María Rodríguez",
            avatar:
              "https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          },
          {
            id: 4,
            name: "Juan Pérez",
            avatar:
              "https://plus.unsplash.com/premium_photo-1689977807477-a579eda91fa2?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          },
        ],
        progress: 75,
      }, */
    ],
    collaborators: [
      /* {
        id: 1,
        name: "Ana García",
        email: "ana.garcia@empresa.com",
        identification: "Gestión",
        status: "started",
        joinDate: "2024-01-15",
      }, */
    ],
    selectedProcess: null,
    results: {},
    loading: false,
  },
  mutations: {
    SET_SELECTED_PROCESS(state, process) {
      state.selectedProcess = process;
    },
    SET_PROCESSES(state, processes) {
      state.processes = processes;
    },
    SET_COLLABORATORS(state, collaborators) {
      state.collaborators = collaborators;
    },
  },
  actions: {
    selectProcess({ commit }, process) {
      commit("SET_SELECTED_PROCESS", process);
      return true;
    },
    setProcesses({ commit }, processes) {
      commit("SET_PROCESSES", processes);
      return true;
    },
    setCollaborators({ commit }, collaborators) {
      commit("SET_COLLABORATORS", collaborators);
      return true;
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/cultura/store.js